export default function trainerDirectory() {
	
return (
	<>
    <div>trainerDirectory</div>
	</>
);
}